<template>
  <div>
    <div class="flex space-x-4 mb-4">
      <DxDateBox type="date" v-model:value="tempDateFilter.start" label="Start Date" display-format="dd/MM/yyyy" />
      <DxDateBox type="date" v-model:value="tempDateFilter.end" label="End Date" display-format="dd/MM/yyyy" />

      <!-- Apply Button -->
      <DxButton text="Apply" type="default" @click="applyDateFilter" />

   
    <DxToolbar>
      <DxItem location="after" widget="dxButton" :options="{
          icon: 'overflow',
          hint: 'More Options',
          elementAttr: { id: 'kebab-button', class: 'kebab-button' },
          onClick: toggleMenu
        }" />
    </DxToolbar>
  </div>
    <DxPivotGrid ref="pivotGrid" :allow-sorting="true" :allow-filtering="true" :show-borders="true" :data-source="dataSource">
      <DxScrolling mode="virtual" />
    </DxPivotGrid>
    <DxContextMenu 
      :items="menuItems" 
      :visible.sync="isMenuVisible" 
      target="#kebab-button" 
      :position="{
        at: 'right bottom',
        my: 'right top',
        of: '#kebab-button',
        collision: 'fit'
      }" 
      @item-click="toggleMenu" 
    />
  </div>
</template>

<script>
import {
  DxPivotGrid,
  DxFieldChooser,
  DxHeaderFilter,
  DxSearch,
  DxScrolling,
  DxFieldPanel,

} from "devextreme-vue/pivot-grid";
import { DxToolbar, DxItem } from "devextreme-vue/toolbar";
import DxDateBox from "devextreme-vue/date-box";
import { DxButton } from "devextreme-vue/button";
import PivotGridDataSource from "devextreme/ui/pivot_grid/data_source";
import CustomStore from "devextreme/data/custom_store";
import { DxContextMenu } from 'devextreme-vue/context-menu';
import { exportPivotGrid } from 'devextreme/excel_exporter';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';

export default {
  components: {
    DxPivotGrid,
    DxFieldChooser,
    DxHeaderFilter,
    DxSearch,
    DxScrolling,
    DxFieldPanel,
    DxDateBox,
    DxButton,
    DxItem,
    DxToolbar,
    DxContextMenu
  },
  props: {
    routeDef: String,
    headersDef: Array,
    slug: String,
    dataRoute: String,
  },
  data() {
    return {
      dataSource: null,
      url: null,
      tempDateFilter: {
        start: null,
        end: null,
      },
      isMenuVisible: false,
      menuItems: [{
        text: 'Export Data',
        icon: 'export',
        onClick: this.exportToExcel
      }],
      itemSelected: false

    };
  },
  methods: {
    toggleMenu(e) {
      this.isMenuVisible = !this.isMenuVisible; 
    },
    onMenuItemClick(e) {
      if (e.itemData.onClick) {
        e.itemData.onClick();
      }
    },
    exportToExcel() {
      const pivotGrid = this.$refs.pivotGrid.instance;
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('PivotGrid Data');

      exportPivotGrid({
        component: pivotGrid,
        worksheet: worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'PivotGridExport.xlsx');
        });
      }).catch((error) => {
        console.error('Error exporting to Excel:', error);
      });
    },
    initializeDataSource() {
      this.dataSource = new PivotGridDataSource({
        retrieveFields: false,
        remoteOperations: true,
        fields: this.headersDef,
        store: new CustomStore({
          key: "id",
          load: (loadOptions) => {
            var parameters = {};
            var startDate = this.formatDate(this.tempDateFilter.start);
            var endDate = this.formatDate(this.tempDateFilter.end);

            parameters.skip = "0";
            parameters.take = "12";
            parameters.group = JSON.stringify(loadOptions.group);
            parameters.group_summary = JSON.stringify(loadOptions.groupSummary);
            parameters.total_summary = JSON.stringify(loadOptions.totalSummary);

            console.log("loadoption values", loadOptions);
            //parameters.filter =  JSON.stringify([["attendance_date",">=","2024-10-31T18:30:00.000Z"],"and",["attendance_date","<=","2024-11-29T18:30:00.000Z"]])  ;
            parameters.filter = JSON.stringify([
              ["attendance_date", ">=", startDate],
              "and",
              ["attendance_date", "<=", endDate],
            ]);
            //parameters.sort = [{"selector":"rlt_employee_attendance","desc":false}];

            var config = {
              params: parameters,
            };

            return axios
              .get(this.url, config)
              .then((response) => {
                return {
                  data: response.data.results.data,
                  summary: response.data.results.summary,
                  totalCount: response.data.results.total,
                };
              })
              .catch(() => {
                throw "Data Loading Error";
              });
          },
        }),
      });
    },

    // Apply Date Filter Method
    applyDateFilter() {
      // Reinitialize DataSource with new date filters
      console.log("Start Date tempDateFilter", this.tempDateFilter.start);
      console.log("End Date tempDateFilter", this.tempDateFilter.end);

      const utcStartDate = this.formatDate(this.tempDateFilter.start);
      const utcEndDate = this.formatDate(this.tempDateFilter.end);

      console.log("Start Date utcStartDate", utcStartDate);
      console.log("End Date utcEndDate", utcEndDate);

      this.initializeDataSource();
      //this.$refs[pivotGridRefKey].instance.refresh();
    },

    convertToUTC(localDate) {
      // Parse the date string to a Date object
      const date = new Date(localDate);
      // Convert to UTC and return ISO string
      return date.toISOString();
    },

    // Format date to backend-compatible format
    formatDate(date) {
      if (!date) return null;
      /*  const formattedDate = date
        .toLocaleDateString("en-IN", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .replace(/\//g, "-");
      return formattedDate; */

      if (!date) return null;
      // Use Intl.DateTimeFormat to format the date in YYYY-MM-DD format
      const formattedDate = new Intl.DateTimeFormat("en-CA", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(new Date(date));

      return formattedDate; // Returns date in YYYY-MM-DD format
    },
  },
  mounted() {
    this.url = route(this.dataRoute, { route_slug: this.slug });
  },
  created() { },
};
</script>